module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-other.svg?df3fa7f255ccd3b6d30e394959c64dae";